module.exports = __webpack_public_path__ + "static/media/mic-speaking1.81c266e7.svg";